module.exports = __webpack_public_path__ + "img/enchanted_quiver.7ed396d6.png";